import React, { useRef, useEffect } from 'react'
import VexFlow, {Accidental} from 'vexflow'

const { Renderer, Stave, StaveNote, Formatter } = VexFlow;


const clefWidth = 30;
const timeWidth = 30;

export function Score({
                        staves = [],
                        clef = 'treble',
                        timeSignature = '4/4',
                        staveWidth = 130,
                        staveHeight = 190,
                      }) {
  const container = useRef<HTMLDivElement>()

  useEffect(() => {
    container.current.replaceChildren();

    const renderer = new Renderer(container.current, Renderer.Backends.SVG);

    const stavesPerRow = Math.floor((container.current.clientWidth - clefWidth - timeWidth - 20) / staveWidth);
    const rowCount = Math.ceil(staves.length / stavesPerRow);


    const clefAndTimeWidth = (clef ? clefWidth : 0) + (timeSignature ? timeWidth : 0);
    renderer.resize(staveWidth * staves.length + clefAndTimeWidth, rowCount * staveHeight)
    let context = renderer.getContext()
    context.setFont('Arial', 10).setBackgroundFillStyle('#eed')

    let currX = 0
    let currY = 0
    let staveMaxHeight = 0
    staves.forEach((notes, i) => {
      if (i % stavesPerRow === 0) {
        currX = 0;
        currY += staveMaxHeight + 30;
        staveMaxHeight = 0;
      }
      const stave = new Stave(currX, currY, staveWidth)
      if (i % stavesPerRow === 0) {
        stave.setWidth(staveWidth + clefAndTimeWidth)
        clef && stave.addClef(clef);
        if (i == 0) {
          timeSignature && stave.addTimeSignature(timeSignature);
        }

      }
      currX += stave.getWidth()
      staveMaxHeight = Math.max(stave.getHeight(), staveMaxHeight);
      stave.setContext(context).draw()

      const processedNotes = notes
        .map(note => (typeof note === 'string' ? { key: note } : note))
        .map(note =>
          Array.isArray(note) ? { key: note[0], duration: note[1] } : note
        )
        .map(({ key, ...rest }) =>
          typeof key === 'string'
            ? {
              key: key.includes('/') ? key : `${key[0]}/${key.slice(1)}`,
              ...rest,
            }
            : rest
        )
        .map(({ key, ...rest }) =>
          typeof key === 'string'
            ? {
              key: key,
              modifier: key.slice(1, key.length-2),
              ...rest,
            }
            : rest
        )
        .map(
          ({ key, keys, modifier, duration = 'q' }) =>
            (typeof modifier === 'string' && modifier.length > 0) ?
              new StaveNote({
                keys: key ? [key] : keys,
                duration: String(duration),
              }).addModifier(new Accidental(modifier))
              :
              new StaveNote({
                keys: key ? [key] : keys,
                duration: String(duration),
              })
        )

      Formatter.FormatAndDraw(context, stave, processedNotes, {
        autoBeam: true,
        alignRests: false
      });
    })
  }, [staves])

  return <div ref={container} />
}
